export default __webpack_public_path__ + "static/media/skovstykket-tenancy-03.465d90fe.jpg";